// extracted by mini-css-extract-plugin
export default {"delivery-results-cell":"_ACQq4IR7lJSpEWkceUO"};